module.exports = __webpack_public_path__ + "static/media/www.bf206f8a.svg";